import type { PropsWithChildren, RefObject } from "react";
import { Head } from '@inertiajs/react';
import NavigationHeader from "@/Components/Navigation/NavigationHeader";
import NavigationFooter from "@/Components/Navigation/NavigationFooter";
import { useAppContext } from "../Providers/AppProvider";

type Props = {
    title?: string,
    className?: string,
}

export default function SiteLayout({ title, children, className }: PropsWithChildren<Props>) {
    const pageTitle = title ? `Our Share | ${title}` : 'Our Share | Official Website';

    return <main className={mc("w-full overflow-x-hidden", className)}>
        <Head title={pageTitle}></Head>
        <NavigationHeader />
        {children}
        <NavigationFooter />
    </main>
}
